export function isWindowDefined() {
  return typeof window !== "undefined";
}
